import Button from '@components/ui/Button';
import IconWrapper from '@components/ui/Icons';
import { useTranslation } from 'next-i18next';

import styles from './AlbyScrollButton.module.scss';

const AlbyScrollButton = ({
  albyRef,
}: {
  albyRef: React.RefObject<HTMLDivElement | null>;
}) => {
  const { t } = useTranslation('pdp');

  return (
    <Button
      className={styles.albyLink}
      handleClick={() =>
        albyRef.current?.scrollIntoView({ behavior: 'smooth' })
      }
      variant="tertiary"
      size="small"
      label={
        <div className={styles.albyLinkContent}>
          <IconWrapper icon="sparkle" height={20} width={20} />
          {t('product.alby.instantAnswers')}
        </div>
      }
    />
  );
};

export default AlbyScrollButton;
